function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhNewCircleLargeFilled, vsTrash, vsEdit, dhWarningFilled } from '@deephaven/icons';
import Log from '@deephaven/log';
import { DraggableItemList, DragUtils, Option, Select, Radio, RadioGroup, Button } from '@deephaven/components';
import AggregationOperation from "./AggregationOperation.js";
import AggregationUtils, { SELECTABLE_OPTIONS } from "./AggregationUtils.js";
import "./Aggregations.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('Aggregations');
function Aggregations(_ref) {
  var isRollup = _ref.isRollup,
    settings = _ref.settings,
    _ref$availablePlaceme = _ref.availablePlacements,
    availablePlacements = _ref$availablePlaceme === void 0 ? ['top', 'bottom'] : _ref$availablePlaceme,
    onChange = _ref.onChange,
    onEdit = _ref.onEdit,
    dh = _ref.dh;
  var aggregations = settings.aggregations,
    showOnTop = settings.showOnTop;
  var options = useMemo(() => SELECTABLE_OPTIONS.filter(option => !aggregations.some(aggregation => aggregation.operation === option) && !(option === AggregationOperation.MEDIAN &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - MEDIAN is not defined in older version of Core
  dh.AggregationOperation.MEDIAN === undefined)), [aggregations, dh]);
  var _useState = useState(options[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOperation = _useState2[0],
    setSelectedOperation = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedRanges = _useState4[0],
    setSelectedRanges = _useState4[1];
  var changeSettings = useCallback(function (changedSettings) {
    var added = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var removed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    onChange(_objectSpread(_objectSpread({}, settings), changedSettings), added, removed);
  }, [onChange, settings]);
  var changeAggregations = useCallback(function (newAggregations) {
    var added = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var removed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    changeSettings({
      aggregations: newAggregations
    }, added, removed);
  }, [changeSettings]);
  var changeShowOnTop = useCallback(newShowOnTop => {
    changeSettings({
      showOnTop: newShowOnTop
    });
  }, [changeSettings]);
  var handleDragStart = useCallback(() => {
    log.debug('handleDragStart');
    DragUtils.startDragging();
  }, []);
  var handleDragEnd = useCallback(_ref2 => {
    var destination = _ref2.destination,
      source = _ref2.source;
    log.debug('handleDragEnd', destination, source);
    DragUtils.stopDragging();
    if (destination == null) {
      return;
    }
    var destinationIndex = destination.index;
    if (source.index < destination.index) {
      destinationIndex += 1;
    }
    var newAggregations = [...aggregations];
    var draggedItems = DragUtils.reorder(newAggregations, selectedRanges, newAggregations, destinationIndex);
    var insertIndex = DragUtils.adjustDestinationIndex(destinationIndex, selectedRanges);
    var newSelectedRanges = [[insertIndex, insertIndex + draggedItems.length - 1]];
    changeAggregations(newAggregations);
    setSelectedRanges(newSelectedRanges);
  }, [changeAggregations, aggregations, selectedRanges, setSelectedRanges]);
  var handleOperationChange = useCallback(operation => {
    setSelectedOperation(operation);
  }, [setSelectedOperation]);
  var handleAdd = useCallback(() => {
    changeAggregations([...aggregations, {
      operation: selectedOperation,
      selected: [],
      invert: true
    }], [selectedOperation]);
  }, [aggregations, selectedOperation, changeAggregations]);
  var handleDeleteClicked = useCallback(itemIndex => {
    var _aggregations$reduce = aggregations.reduce((_ref3, aggregation, index) => {
        var _ref4 = _slicedToArray(_ref3, 2),
          keepSoFar = _ref4[0],
          removeSoFar = _ref4[1];
        if (index === itemIndex) {
          removeSoFar.push(aggregation.operation);
        } else {
          keepSoFar.push(aggregation);
        }
        return [keepSoFar, removeSoFar];
      }, [[], []]),
      _aggregations$reduce2 = _slicedToArray(_aggregations$reduce, 2),
      keep = _aggregations$reduce2[0],
      remove = _aggregations$reduce2[1];
    changeAggregations(keep, [], remove);
  }, [aggregations, changeAggregations]);
  var handleAggregationSelectionChange = useCallback(newSelectedRanges => {
    setSelectedRanges(newSelectedRanges);
  }, [setSelectedRanges]);
  var handleAggregationSelect = useCallback(itemIndex => {
    var aggregation = aggregations[itemIndex];
    if (!AggregationUtils.isRollupOperation(aggregation.operation)) {
      onEdit(aggregation);
    }
  }, [aggregations, onEdit]);
  var handleShowOnTopChange = useCallback(value => {
    changeShowOnTop(value === 'true');
  }, [changeShowOnTop]);
  useEffect(function setDefaultOperation() {
    if (options.length > 0 && !options.includes(selectedOperation)) {
      setSelectedOperation(options[0]);
    }
  }, [options, selectedOperation]);
  var renderAggregation = useCallback(_ref5 => {
    var item = _ref5.item,
      itemIndex = _ref5.itemIndex,
      _ref5$isClone = _ref5.isClone,
      isClone = _ref5$isClone === void 0 ? false : _ref5$isClone,
      selectedCount = _ref5.selectedCount;
    var text = item.operation;
    var badgeText = isClone ? "".concat(selectedCount) : undefined;
    var className = isClone ? 'item-list-item-clone' : undefined;
    var isRollupOperation = AggregationUtils.isRollupOperation(item.operation);
    var isRollupProhibited = AggregationUtils.isRollupProhibited(item.operation);
    var isEditable = !isClone && !isRollupOperation;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames('item-list-item-content', 'draggable-item-list-item-content', className),
        children: [/*#__PURE__*/_jsxs("span", {
          className: "title",
          children: [text, !isRollup && isRollupOperation && /*#__PURE__*/_jsxs("span", {
            className: "small text-warning",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: dhWarningFilled
            }), " Requires rollup"]
          }), isRollup && isRollupProhibited && /*#__PURE__*/_jsxs("span", {
            className: "small text-warning",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: dhWarningFilled
            }), " Not available on rollups"]
          })]
        }), DraggableItemList.renderBadge({
          text: badgeText
        }), DraggableItemList.renderHandle()]
      }), !isClone && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-edit",
          icon: vsEdit,
          tooltip: "Edit Columns",
          onClick: () => onEdit(item),
          disabled: !isEditable
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-delete",
          icon: vsTrash,
          tooltip: "Delete Aggregation",
          onClick: () => handleDeleteClicked(itemIndex)
        })]
      })]
    });
  }, [handleDeleteClicked, onEdit, isRollup]);
  var isOptionsShown = options.length > 0;
  var isAggregationsShown = aggregations.length > 0;
  return /*#__PURE__*/_jsxs("div", {
    className: "aggregations",
    children: [isOptionsShown && /*#__PURE__*/_jsxs("div", {
      className: "form-inline",
      children: [/*#__PURE__*/_jsx(Select, {
        onChange: handleOperationChange,
        value: selectedOperation,
        children: options.map(option => /*#__PURE__*/_jsx(Option, {
          value: option,
          children: option
        }, option))
      }), /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "btn btn-link btn-add",
        onClick: handleAdd,
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhNewCircleLargeFilled
        }), "Add Aggregation"]
      })]
    }), isOptionsShown && isAggregationsShown && /*#__PURE__*/_jsx("hr", {}), isAggregationsShown && /*#__PURE__*/_jsxs(_Fragment, {
      children: [!isRollup && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("label", {
          id: "placement-options-label",
          children: "Placement:\xA0"
        }), /*#__PURE__*/_jsxs(RadioGroup, {
          "aria-labelledby": "placement-options-label",
          marginStart: "size-125",
          orientation: "horizontal",
          onChange: handleShowOnTopChange,
          value: "".concat(showOnTop),
          children: [/*#__PURE__*/_jsx(Radio, {
            value: "true",
            isDisabled: !availablePlacements.includes('top'),
            children: "Top"
          }), /*#__PURE__*/_jsx(Radio, {
            value: "false",
            isDisabled: !availablePlacements.includes('bottom'),
            children: "Bottom"
          })]
        })]
      }), /*#__PURE__*/_jsx(DragDropContext, {
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/_jsx(DraggableItemList, {
          className: "selected-aggregations",
          itemCount: aggregations.length,
          items: aggregations,
          renderItem: renderAggregation,
          offset: 0,
          onSelectionChange: handleAggregationSelectionChange,
          onSelect: handleAggregationSelect,
          selectedRanges: selectedRanges,
          isMultiSelect: true
        })
      })]
    })]
  });
}
export default Aggregations;
//# sourceMappingURL=Aggregations.js.map